import { getType } from 'typesafe-actions';
import { sourceDocumentLoaded } from '../../documents/actions/source-document.actions';
import { SourceDocumentActions } from '../../documents/actions/source-document.types';
import {
  fetchPredictionsError,
  nazgulPredictionsSuccess,
  requestNazgulPredictions,
  setPredictionModels,
} from '../actions/predictions.actions';
import { PredictionsActions } from '../actions/predictions.types';
import { PredictionsState } from '../models/predictions.model';
import { KeyValueMap } from '../../common/types/KeyValueMap.type';
import { PredictionModel } from '../models/prediction-model.model';

const defaultPredictionsState: PredictionsState = {
  predictionsStatus: 'ready',
  predictionModels: {},
};
export function predictionsReducer(
  state: PredictionsState = defaultPredictionsState,
  action: PredictionsActions | SourceDocumentActions,
): PredictionsState {
  switch (action.type) {
    case getType(requestNazgulPredictions):
      return {
        ...state,
        predictionsStatus: 'running',
      };
    case getType(nazgulPredictionsSuccess):
      return {
        ...state,
        predictionsStatus: 'ready',
      };
    case getType(fetchPredictionsError):
      return {
        ...state,
        predictionsStatus: 'ready',
      };
    case getType(sourceDocumentLoaded):
      return {
        ...state,
        predictionsStatus: 'ready',
      };
    case getType(setPredictionModels):
      const models = KeyValueMap.usingPropertyKey<PredictionModel>(
        action.payload,
        'modelId',
      );
      return {
        ...state,
        predictionModels: models,
      };
    default:
      return state;
  }
}
